module.exports = __webpack_public_path__ + "static/media/YB5F16_1.7006d05e.jpg";